import style from './TableSelect.module.css'
import { ArrowSelect } from '../../UI/ArrowSelect/ArrowSelect'
import { useDispatch, useSelector } from 'react-redux'
import { closeAllSelect, openOrClose } from '../../Redux/Slices/Select/Select';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import {ReactComponent as Geolocate} from '../../Assets/icons/geolocate.svg'

export function LocationSelect({options = [], value, setValue}) {
    const dispatch = useDispatch()
    const isOpen = useSelector((state) => state.select.LocationSelect)
    const [selectOptions, setSelectOptions] = useState(options)
    const ref = useRef(null)

    useEffect(() => {
        setSelectOptions(options)
    },[options])
    
    const setIsOpen = () => {
        dispatch(openOrClose('LocationSelect'))
        isOpen && dispatch(closeAllSelect())
    }

    return <div className={`${style.table___container} select`} >
        <div className={`${style.table__value}  ${style.location__container}`}  style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}} onClick={(e) => setIsOpen()}> 
            <Geolocate />   
            <span style={{color: value?.competitors_id ? 'white' : '#7e8279'}}>
            {value.name}
            </span>  <ArrowSelect />
        </div> 
        <div ref={ref} style={{minWidth: '260px'}} className={`${style.table__list} ${isOpen ? style.active : ''} overlay`}>
        <div className={style.modal__container}>
            <div className={style.scrollContainer}>
                {selectOptions.map((item, index) => {
                    const arrname = item?.name?.split(' (')
                    return <div key={index} className={`${style.table__list_item} ${item.name === value.name ? style.active_item : ''} ${style.map__list_subname}`} onClick={() => {  
                            setValue(item)
                    }}>
                        {/* {item.name} */}
                        <p className={style.name}>{arrname ? arrname[0] : item.name}</p>
                        <p className={style.subName}>{`${arrname?.length > 1 ? '(' + arrname[1] : ''}`}</p>
                    </div>
                    
                })}
            </div>
        </div>
        </div>
    </div>
}